import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-confirmacao-painel-manutencoes',
    templateUrl: './confirmacao-painel-manutencoes.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ConfirmacaoPainelManutencoesComponent {

  @Input() confirmacaoPainelManutencoes: boolean = false;
  @Output() confirmacaoPainelManutencoesFechou = new EventEmitter();

  constructor() { }

  fecharAlertConfirmacao(acao: string) { this.confirmacaoPainelManutencoesFechou.emit(acao); }
}
